<template>
  <a-drawer
      title="兑换码详细记录"
      placement="right"
      :width="'80%'"
      :visible="open"
      :closable="true"
      @close="onClose"
  >
    <!-- 批次ID + 时间范围 + 日期选择器 + 搜索按钮 一行显示 -->
    <div class="header-row">
      <span class="batch-info">批次ID：{{ comboId }}</span>
      <a-range-picker
          v-model="innerRange"
          style="margin-left: 12px"
          :allowClear="true"
      />
      <a-button
          type="primary"
          @click="loadData"
          style="margin-left: 12px"
      >
        搜索
      </a-button>
      <a-button
          @click="reset"
          style="margin-left: 8px"
      >
        重置
      </a-button>
    </div>

    <a-table
        :data-source="list"
        :columns="columns"
        :pagination="pagination"
        :loading="loading"
        rowKey="id"
        @change="handlePageChange"
        size="middle"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'playTime'">
          {{ record.playTime }}
        </template>
      </template>
    </a-table>
  </a-drawer>
</template>

<script>
import dayjs from 'dayjs'
import {convertCodeTotalDetail} from '@/api/statistics/convert-code'

export default {
  name: 'DetailDrawer',
  props: {
    comboId: {
      type: String,
      required: true
    },
    open: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      list: [],
      innerRange: [], // 时间范围，默认空
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      columns: [
        {title: '日期时间', dataIndex: 'convertTime', key: 'convertTime'},
        {title: '用户ID', dataIndex: 'userId', key: 'userId'},
        {title: '用户名称', dataIndex: 'userName', key: 'userName'},
        {title: '兑换码', dataIndex: 'convertCode', key: 'convertCode'},
        {title: '短剧名称', dataIndex: 'convertVideoName', key: 'convertVideoName'}
      ]
    }
  },
  computed: {
    dateRangeText() {
      if (this.innerRange.length === 2) {
        return `${this.innerRange[0].format('YYYY-MM-DD')} 至 ${this.innerRange[1].format('YYYY-MM-DD')}`
      }
      return '无时间范围'
    }
  },
  watch: {
    open(val) {
      if (val) {
        this.reset()
        this.loadData() // 抽屉打开立即加载数据
      }
    },
    comboId() {
      if (this.open) {
        this.reset()
        this.loadData()
      }
    }
  },
  methods: {
    reset() {
      this.innerRange = []
      this.pagination.current = 1
      this.loadData()
    },
    onClose() {
      this.$emit('update:open', false)
    },
    handlePageChange(pagination) {
      this.pagination.current = pagination.current
      this.loadData()
    },
    loadData() {
      if (!this.comboId) return

      this.loading = true

      // 参数里如果选了时间范围则传，否则不传时间参数
      const params = {
        comboId: this.comboId,
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize
      }

      if (this.innerRange.length === 2) {
        params.startDate = dayjs(this.innerRange[0]).format('YYYY-MM-DD')
        params.endDate = dayjs(this.innerRange[1]).format('YYYY-MM-DD')
      }

      convertCodeTotalDetail(params)
          .then(res => {
            this.list = res.data.records || []
            this.pagination.total = res.data.total || 0
          })
          .finally(() => {
            this.loading = false
          })
    }
  }
}
</script>

<style scoped>
.header-row {
  display: flex;
  align-items: center;
  white-space: nowrap; /* 不换行 */
  padding-bottom: 16px;
  font-size: 14px;
  color: #595959;
}

.batch-info {
  font-weight: 600;
  margin-right: 8px;
}

.date-range-text {
  margin-right: 8px;
  color: #888;
}
</style>
